import { apiConnection } from "@/services/api-connection";
import { messengerMessageManager } from "@/services/messenger-message/messenger-message-manager";
import { i18n } from "@/i18n";

const URL_LIST = "/app/triad/list/";
const URL_ONE = "/app/triad/";
const URL_PDF = "/app/triad/pdf/";

class TriadManager {
  APPRENTICE_PROFILE = 1;
  TUTOR_PROFILE = 2;
  APPRENTICE_MASTER_PROFILE = 3;
  STUDEA_MANAGER_PROFILE = 4;
  STUDEA_ADMIN_PROFILE = 5;
  loadTriadList = (id, archive, search = "") => {
    return apiConnection.get(URL_LIST + id, { archive: archive, search: search }, true).then((response) => response);
  };
  loadOne = (id) => {
    return apiConnection.get(URL_ONE + id, {}, true).then((response) => response);
  };

  pdf(id, keyDates = false) {
    return apiConnection.get(URL_PDF + id, { keyDates: keyDates ? 1 : 0 }).then((res) => {
      messengerMessageManager.processMessage(res);
    });
  }

  userCanSeeQuestionnaireMark(profile, questionnaire) {
    return (
      profile === this.STUDEA_MANAGER_PROFILE ||
      profile === this.STUDEA_ADMIN_PROFILE ||
      !!(
        questionnaire &&
        questionnaire.marksVisibleBy &&
        Array.isArray(questionnaire.marksVisibleBy) &&
        questionnaire.marksVisibleBy.includes(profile)
      )
    );
  }

  setProfileLabel(
    key,
    apprenticeProfileLabel = {},
    tutorProfileLabel = {},
    apprenticeMasterProfileLabel = {},
    studeaManagerProfileLabel = {},
  ) {
    switch (key) {
      case this.APPRENTICE_PROFILE:
        return apprenticeProfileLabel?.title ? apprenticeProfileLabel.title : i18n.global.t("apprentice");
      case this.TUTOR_PROFILE:
        return tutorProfileLabel?.title ? tutorProfileLabel.title : i18n.global.t("tutor");
      case this.APPRENTICE_MASTER_PROFILE:
        return apprenticeMasterProfileLabel?.title
          ? apprenticeMasterProfileLabel.title
          : i18n.global.t("apprenticeMaster");
      case this.STUDEA_MANAGER_PROFILE:
        return studeaManagerProfileLabel?.title ? studeaManagerProfileLabel.title : i18n.global.t("studeaManager");
    }
  }
}

export const triadManager = new TriadManager();
